import { useEffect, useMemo, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
  Box, Paper, Typography, useTheme,
  Tooltip,
  Button,
  FormControl,
  FormControlLabel,
  Checkbox as MuiCheckBox,
  RadioGroup as MuiRadioGroup,
  InputLabel,
  MenuItem,
  Select,
  Icon,
  Card,
  CardActionArea,
  CardMedia
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { DataGrid, GridCellParams, GridColDef } from "@mui/x-data-grid";
import { ptBR } from '@mui/x-data-grid/locales';
import { FranquiaService, IDetalheFranquia, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import { IDadosDetalhesTrocaPosicao, IDadosEstatisticas, IDadosHistoricoJogador, IDadosHistoricoLiga, IDadosHistoricoTitulo, IDadosMediaTrocaPosicao, IDadosMetaJogador, IDadosSalvarTrocaPosicao, IDadosUltimosContratos, IDadosUltimosContratosTrocaPosicao, IListagemJogador, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { Loading } from "../../shered/components/loading/Loading";
import { TDropOptions, UtilidadeService, lstPosicaoAmericano, lstReferenciasPosicao, lstReferenciasPosicaoAmericano, lstReferenciasPosicaoConfronto } from "../../shered/services/api/utilidades/UtilidadesService";
import { DraftService } from "../../shered/services/api/draft/DraftService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { TDropOptionsJogador } from "../escalacao/DetalheDeEscalacao";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import dayjs from "dayjs";
import CookieService from "../../shered/services/autenticacao/CookieService";


interface IGridColumnHeaderParams {
  ano1: string;
  ano2: string;
  ano3: string;
  ano4: string;
  ano5: string;
}

export const DetalheDeJogadores: React.FC = () => {
  const theme = useTheme();
  const { formRef, save } = useVForm();
  const user = CookieService.get("access_user");
  const { id } = useParams<"id">();
  let codLocal = localStorage.getItem("@codigoLiga");
  const { themeName } = useAppThemeContext();
  const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
  const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../../semimagemescudo.png");
  const [showImagemLiga, setShowImagemLiga] = useState<any>("../../../semimagemescudo.png");
  const [imagemTrofelConferencia, setImagemTrofelConferencia] = useState<any | null>("../../../newConferencia.png");
  const [imagemTrofelDivisao, setImagemTrofelDivisao] = useState<any | null>("../../../newDivisao.png");
  const [imagemTrofelLiga, setImagemTrofelLiga] = useState<any | null>("../../../newLiga.png");
  const [codigoFranquia, setCodigoFranquia] = useState(0);
  const [codigoTipoPosicaoConfronto, setCodigoTipoPosicaoConfronto] = useState(0);
  const [codigoFranquiaContrato, setCodigoFranquiaContrato] = useState(0);
  const [codigoJogadorSelecionado, setCodigoJogadorSelecionado] = useState(0);
  const navigate = useNavigate();
  const [showModalMensagem, setShowModalMensagem] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated, logout } = useAuthContext();
  const [edicao, setEdicao] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [aceitaTrocaPosicao, setAceitaTrocaPosicao] = useState(false);
  const [comissarioLiga, setComissarioLiga] = useState(false);
  const [redirecionar, setRedirecionar] = useState("");
  const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
  const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([]);
  const [fotoJogador, setFotoJogador] = useState<string>("");
  const [nomeJogador, setNomeJogador] = useState<string>("");
  const [dadosTrocaPosicao, setDadosTrocaPosicao] = useState<IDadosDetalhesTrocaPosicao>();
  const [dadosJogadorNBA, setDadosJogadorNBA] = useState<IDadosMediaTrocaPosicao[]>([]);
  const [dadosJogadorNBACab, setDadosJogadorNBACab] = useState<IDadosMediaTrocaPosicao[]>([]);
  const [dadosJogadorLiga, setDadosJogadorLiga] = useState<IDadosMediaTrocaPosicao[]>([]);
  const [listaTitulos, setListaTitulos] = useState<IDadosHistoricoTitulo[]>([]);

  const [franquiaJogador, setFranquiaJogador] = useState<string>("");
  const [salario1, setSalario1] = useState<string>("");
  const [salario2, setSalario2] = useState<string>("");
  const [salario3, setSalario3] = useState<string>("");
  const [salario4, setSalario4] = useState<string>("");
  const [salario5, setSalario5] = useState<string>("");

  const [posicao1, setPosicao1] = useState(0);
  const [posicao2, setPosicao2] = useState(0);
  const [posicao3, setPosicao3] = useState(0);

  const [chkContundido, setChkContundido] = useState(false);
  const [disableForaNba, setDisableForaNba] = useState(false);
  const [disableContundido, setDisableContundido] = useState(false);

  const [chkRestrito, setChkRestrito] = useState(false);
  const [meuJogador, setMeuJogador] = useState(false);
  const [voltarPagina, setVoltarPagina] = useState("J");
  const [cryptFranquia, setCryptFranquia] = useState("");
  const [chkForaNba, setChkForaNba] = useState(false);
  const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
  const [nomeFranquia, setNomeFranquia] = useState<string>("");
  const [ultimosContratosRows, setUltimosContratosRows] = useState<IDadosUltimosContratosTrocaPosicao[]>([]);
  const [lstDadosHistorico, setLstDadosHistorico] = useState<IDadosHistoricoLiga[]>([]);
  const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
    acao: false,
    label: "",
    tipo: "error",
    mensagem: "Sessão Expirada!",
    display: "none",
    titulo: "Atenção"
  });

  const [ast, setAst] = useState(0);
  const [blk, setBlk] = useState(0);
  const [dreb, setDreb] = useState(0);
  const [fga, setFga] = useState(0);
  const [fgm, setFgm] = useState(0);
  const [fgmp, setFgmp] = useState(0);
  const [fta, setFta] = useState(0);
  const [ftm, setFtm] = useState(0);
  const [ftmp, setFtmp] = useState(0);
  const [min, setMin] = useState(0);
  const [mplu, setMplu] = useState(0);
  const [oreb, setOreb] = useState(0);
  const [pf, setPf] = useState(0);
  const [pts, setPts] = useState(0);
  const [reb, setReb] = useState(0);
  const [stl, setStl] = useState(0);
  const [threepa, setThreepa] = useState(0);
  const [threepm, setThreepm] = useState(0);
  const [threepmp, setThreepmp] = useState(0);
  const [to, setTo] = useState(0);

  const [listaPosicoes, setListaPosicoes] = useState<ILstDrop[]>([]);
  const [listaPosicoesNBA, setListaPosicoesNBA] = useState<string[]>([]);
  const [listaMetaJogadorRows, setListaMetaJogadorRows] = useState<IDadosMetaJogador[]>([]);

  useEffect(() => {
    setIsLoading(true);
    setRemoveLoading(false);
    if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
      setShowModalMensagem(true);
      setDadosModalMensagem({
        acao: true,
        label: "",
        tipo: "warning",
        mensagem: "Favor selecionar uma liga!",
        display: "none",
        titulo: "Atenção"
      });
      setIsLoading(false);
      setRemoveLoading(true);
      setRedirecionar(`/usuario/liga/${codLocal}`);
      return;
    }
    else {
      if (id !== null && id !== undefined && id !== "") {
        const resultCrypt = UtilidadeService.decrypt(id);
        const dadosCrupt = resultCrypt?.split("|");
        const codigoFranquia = dadosCrupt !== undefined ? UtilidadeService.crypt(dadosCrupt[2].toString()) : "";
        const codigoJog = dadosCrupt !== undefined ? dadosCrupt[1] : 0;
        setVoltarPagina(dadosCrupt !== undefined ? dadosCrupt[0] : "J");
        setCryptFranquia(codigoFranquia !== undefined ? codigoFranquia : "");
        setCodigoJogadorSelecionado(dadosCrupt !== undefined ? Number(codigoJog) : 0);
        setIsLoading(true);
        setRemoveLoading(false);
        const fetchData = async () => {
          await UtilidadeService.getTemporadas(true, 0)
            .then((result) => {

              const tmps = result.data.dado;
              let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
              setLstTemporadas(lstTemporadasAux);
            })
            .catch((errors) => {
              setShowModalMensagem(true);
              setIsLoading(false);
              setRemoveLoading(true);
              if (errors.response.status === 401) {
                setDadosModalMensagem({
                  acao: true,
                  label: "",
                  tipo: "info",
                  mensagem: "Sessão expirada!",
                  display: "none",
                  titulo: "Atenção"
                });
                logout();
                setRedirecionar("0");
                return;
              }
              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: errors.response.data.mensagem,
                display: "none",
                titulo: "Atenção"
              });
            });
          await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
            .then((result) => {
              const liga = result.dado;
              setDadosLiga(liga);
              setCodigoFranquia(liga.codigo_Franquia);
              setAceitaTrocaPosicao(liga.abertura_Troca_Posicao);
              setCodigoTipoPosicaoConfronto(liga.codigo_Tipo_Posicao_Confronto);
              setIsLoading(false);
              setRemoveLoading(true);
              setComissarioLiga(liga.comissario_Usuario);
              CarregarDadosJogador(Number(codigoJog), liga.codigo, liga.codigo_Franquia, liga.comissario_Usuario, liga.codigo_Tipo_Posicao_Confronto);
            })
            .catch((errors) => {
              setShowModalMensagem(true);
              setIsLoading(false);
              setRemoveLoading(true);
              if (errors.response.status === 401) {
                setDadosModalMensagem({
                  acao: true,
                  label: "",
                  tipo: "info",
                  mensagem: "Sessão expirada!",
                  display: "none",
                  titulo: "Atenção"
                });
                logout();
                setRedirecionar("0");
                return;
              }

              setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "error",
                mensagem: errors.response.data.mensagem,
                display: "none",
                titulo: "Atenção"
              });
              setRedirecionar(`/usuario/liga/${codLocal}`);
              return;
            });
        }
        fetchData();
      }
    }
  }, [codigoLiga]);

  const CarregarDadosJogador = async (codigoJogador: number, codigoLiga: number, codigoFranquia: number, comissario: boolean, tipoPosicaoConfronto: number) => {

    await JogadorService.getDadosJogadorPorLigaFranquia(codigoJogador, codigoLiga, codigoFranquia)
      .then((result) => {
        setIsLoading(false);
        let res = result.dado;
        setDadosTrocaPosicao(res);
        setListaTitulos(res.historico_Titulo);
        setListaPosicoesNBA(res.posicoes_Apta_NBA);
        setListaMetaJogadorRows(res.meta_Jogador_Player_Option);
        let posicao: ILstDrop;
        let codP1 = 0;
        let codP2 = 0;
        let codP3 = 0;
        const lstPosicao = tipoPosicaoConfronto !== 2 ? lstReferenciasPosicao : lstPosicaoAmericano;
        if (!comissario) {
          res.posicoes_Apta_NBA.forEach(pos => {
            if (listaPosicoes.find(f => f.label === pos) === undefined) {
              posicao = {
                label: lstPosicao.find(p => p.label === pos)?.label ?? "",
                codigo: lstPosicao.find(p => p.label === pos)?.codigo ?? 0
              }
              listaPosicoes.push(posicao);
            }
          })

          posicao = {
            label: lstPosicao.find(p => p.label === res.posicao_1)?.label ?? "",
            codigo: lstPosicao.find(p => p.label === res.posicao_1)?.codigo ?? 0
          }

          codP1 = posicao.codigo;

          if (res.posicao_2 !== null) {
            posicao = {
              label: lstPosicao.find(p => p.label === res.posicao_2)?.label ?? "",
              codigo: lstPosicao.find(p => p.label === res.posicao_2)?.codigo ?? 0
            }
            codP2 = posicao.codigo;
          }
          if (res.posicao_3 !== null) {

            posicao = {
              label: lstPosicao.find(p => p.label === res.posicao_3)?.label ?? "",
              codigo: lstPosicao.find(p => p.label === res.posicao_3)?.codigo ?? 0
            }
            //if (listaPosicoes.find(f => f.label === res.posicao_3) === undefined) {
            codP3 = posicao.codigo;
            //}
          }
        }
        if (comissario) {

          res.posicoes_Apta_NBA.forEach(pos => {
            if (listaPosicoes.find(f => f.label === pos) === undefined) {
              posicao = {
                label: lstPosicao.find(p => p.label === pos)?.label ?? "",
                codigo: lstPosicao.find(p => p.label === pos)?.codigo ?? 0
              }
              listaPosicoes.push(posicao);
            }
          })
          lstPosicao.forEach((element) => {
            if (listaPosicoes.find(f => f.codigo === element.codigo) === undefined) {
              posicao = {
                label: `* ${lstPosicao.find(p => p.codigo === element.codigo)?.label ?? ""}`,
                codigo: lstPosicao.find(p => p.codigo === element.codigo)?.codigo ?? 0
              }
              listaPosicoes.push(posicao);
            }
          });
          posicao = {
            label: listaPosicoes.find(p => p.label.replace("* ", "") === res.posicao_1)?.label ?? "",
            codigo: listaPosicoes.find(p => p.label.replace("* ", "") === res.posicao_1)?.codigo ?? 0
          }
          if (listaPosicoes.find(f => f.label.replace("* ", "") === res.posicao_1) === undefined) {
            listaPosicoes.push(posicao);
          }
          codP1 = posicao.codigo;
          if (res.posicao_2 !== null && res.posicao_2 !== "") {
            posicao = {
              label: listaPosicoes.find(p => p.label.replace("* ", "") === res.posicao_2)?.label ?? "",
              codigo: listaPosicoes.find(p => p.label.replace("* ", "") === res.posicao_2)?.codigo ?? 0
            }
            if (listaPosicoes.find(f => f.label.replace("* ", "") === res.posicao_2) === undefined) {
              listaPosicoes.push(posicao);
              codP2 = posicao.codigo;

            }
            else {
              codP2 = posicao.codigo;
            }
          }
          if (res.posicao_3 !== null && res.posicao_3 !== "") {

            posicao = {
              label: listaPosicoes.find(p => p.label.replace("* ", "") === res.posicao_3)?.label ?? "",
              codigo: listaPosicoes.find(p => p.label.replace("* ", "") === res.posicao_3)?.codigo ?? 0
            }
            if (listaPosicoes.find(f => f.label.replace("* ", "") === res.posicao_3) === undefined) {
              listaPosicoes.push(posicao);
              codP3 = posicao.codigo;
            }
            else {
              codP3 = posicao.codigo;
            }
          }
        }

        setPosicao1(codP1);
        setPosicao2(codP2);
        setPosicao3(codP3);
        setChkContundido(res.contundido);
        setDisableContundido(res.contundido && comissario);
        setDisableForaNba(res.fora_NBA && comissario);
        setChkRestrito(res.restrito);
        setChkForaNba(res.fora_NBA);
        setNomeFranquia(res.Nome_Franquia_Contrato);
        setSalario1(res.ano_Contrato_1);
        setSalario2(res.ano_Contrato_2);
        setSalario3(res.ano_Contrato_3);
        setSalario4(res.ano_Contrato_4);
        setSalario5(res.ano_Contrato_5);
        setCodigoFranquiaContrato(res.codigo_Franquia_Contrato);

        let atualizarJogador = (comissario || res.codigo_Franquia_Contrato === codigoFranquia) && res.codigo_Franquia_Contrato !== 0;
        setMeuJogador(atualizarJogador);
        setDadosJogadorNBA(res.media_NBA);
        setDadosJogadorNBACab(res.media_NBA.slice(0, 1));
        setDadosJogadorLiga(res.media_Liga);
        setUltimosContratosRows(res.ultimos_Contratos_Liga);
        setLstDadosHistorico(res.historico_Liga);
        //CarregarHistoricoJogadorLiga(codigoJogador, codigoLiga);

      }).catch((errors) => {
        setIsLoading(false);
        setShowModalMensagem(true);
        setRemoveLoading(true);
        if (errors.response !== undefined) {
          if (errors.response.status === 401) {
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: "Sessão expirada!",
              display: "none",
              titulo: "Atenção"
            });
            logout();
            setRedirecionar("0");
            return;
          }
          else {
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            return;
          }
        }
        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "error",
          mensagem: "Não foi possível cadastrar os dados do lance! Favor entrar em contato com a TI.",
          display: "none",
          titulo: "Atenção"
        });
      });
  }

  const CarregarHistoricoJogadorLiga = async (codigoJogador: number, codigoLiga: number) => {
    await JogadorService.getDadosHistoricoJogadorLiga(codigoJogador, codigoLiga)
      .then((result) => {
        setIsLoading(false);

      }).catch((errors) => {
        setIsLoading(false);
        setShowModalMensagem(true);
        setRemoveLoading(true);
        if (errors.response.status === 401) {
          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "info",
            mensagem: "Sessão expirada!",
            display: "none",
            titulo: "Atenção"
          });

          logout();
          setRedirecionar("0");
          return;
        }
        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "error",
          mensagem: errors.response.data.mensagem,
          display: "none",
          titulo: "Atenção"
        });
        return;
      });
  }

  const handleSave = async (dados: any) => {

  };

  const columnsContratos: GridColDef[] = [
    {
      field: 'nome_Franquia',
      headerName: 'FRANQUIA',
      editable: false,
      flex: 1,
      minWidth: 120,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: `ano_Contrato_1`,
      headerName: `ANO 1`,
      flex: 1,
      minWidth: 100,
      editable: false,
      sortable: UtilidadeService.isMobile() ? false : true,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => params.value > 0 ? `R$ ${moedaRealLocaleValue(params.value)}` : "-",
    }, {
      field: `ano_Contrato_2`,
      headerName: `ANO 2`,
      flex: 1,
      minWidth: 100,
      editable: false,
      sortable: UtilidadeService.isMobile() ? false : true,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => params.value > 0 ? `R$ ${moedaRealLocaleValue(params.value)}` : "-",
    }, {
      field: `ano_Contrato_3`,
      headerName: `ANO 3`,
      flex: 1,
      minWidth: 100,
      editable: false,
      sortable: UtilidadeService.isMobile() ? false : true,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => params.value > 0 ? `R$ ${moedaRealLocaleValue(params.value)}` : "-",
    }, {
      field: `ano_Contrato_4`,
      headerName: `ANO 4`,
      flex: 1,
      minWidth: 100,
      editable: false,
      sortable: UtilidadeService.isMobile() ? false : true,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => params.value > 0 ? `R$ ${moedaRealLocaleValue(params.value)}` : "-",
    }, {
      field: `ano_Contrato_5`,
      headerName: `ANO 5`,
      flex: 1,
      minWidth: 100,
      editable: false,
      sortable: UtilidadeService.isMobile() ? false : true,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => params.value > 0 ? `R$ ${moedaRealLocaleValue(params.value)}` : "-",
    },
  ];

  const columnsMetas: GridColDef[] = [
    {
      field: 'codigo',
      headerName: 'CÓDIGO',
      editable: false,
      flex: 1,
      minWidth: 120,
      headerClassName: 'super-app-theme--header',
      align: "center",
      headerAlign: "center",
    },
    {
      field: 'descricao_Item_Player_Option',
      headerName: 'META',
      editable: false,
      flex: 1,
      minWidth: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: "quantidade_Meta",
      headerName: "QTD. META",
      flex: 1,
      maxWidth: 130,
      editable: false,
      sortable: UtilidadeService.isMobile() ? false : true,
      headerClassName: 'super-app-theme--header',
      align: "center",
      headerAlign: "center",
    },
    {
      field: "quantidade_Atingida",
      headerName: "QTD. ATINGIDA",
      flex: 1,
      maxWidth: 130,
      editable: false,
      sortable: UtilidadeService.isMobile() ? false : true,
      headerClassName: 'super-app-theme--header',
      align: "center",
      headerAlign: "center",
    },
    {
      field: "atingida",
      headerName: "ATINGIDA",
      flex: 1,
      maxWidth: 130,
      editable: false,
      sortable: UtilidadeService.isMobile() ? false : true,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => (!params.value ? "NÃO" : "SIM"),
      align: "center",
      headerAlign: "center",
      
    },
    {
      field: `pontuacao`,
      headerName: "PONTUAÇÃO",
      flex: 1,
      maxWidth: 130,
      editable: false,
      sortable: UtilidadeService.isMobile() ? false : true,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => params.value > 0 ? params.value : "-",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "descricao_Temporada",
      headerName: "TEMPORADA",
      flex: 1,
      maxWidth: 130,
      editable: false,
      sortable: UtilidadeService.isMobile() ? false : true,
      headerClassName: 'super-app-theme--header',
    },

  ];

  const [dadosHeader, setDadosHeader] = useState<IGridColumnHeaderParams>({
    ano1: "", ano2: "", ano3: "", ano4: "", ano5: ""
  });

  // const carregarCabecalhoTemporadas = (codigo: number) => {
  //   UtilidadeService.getDescricaoTemporadoPorCodigoLiga(codigo)
  //     .then((result) => {
  //       setIsLoading(false);
  //       const tmps = result.dado;
  //       setDadosHeader({
  //         ano1: tmps.descricao_Ano1,
  //         ano2: tmps.descricao_Ano2,
  //         ano3: tmps.descricao_Ano3,
  //         ano4: tmps.descricao_Ano4,
  //         ano5: tmps.descricao_Ano5
  //       });

  //       setColumnsContratos([
  //         {
  //           field: 'nome_Franquia',
  //           headerName: 'FRANQUIA',
  //           editable: false,
  //           flex: 1,
  //           minWidth: 120,
  //           headerClassName: 'super-app-theme--header',
  //         },
  //         {
  //           field: `ano_Contrato_1`,
  //           headerName: `${tmps.descricao_Ano1}`,
  //           flex: 1,
  //           minWidth: 100,
  //           editable: false,
  //           sortable: UtilidadeService.isMobile() ? false : true,
  //           headerClassName: 'super-app-theme--header',
  //           renderCell: (params) => `R$ ${moedaRealLocaleValue(params.value)}`,
  //         }, {
  //           field: `ano_Contrato_2`,
  //           headerName: `${tmps.descricao_Ano2}`,
  //           flex: 1,
  //           minWidth: 100,
  //           editable: false,
  //           sortable: UtilidadeService.isMobile() ? false : true,
  //           headerClassName: 'super-app-theme--header',
  //           renderCell: (params) => `R$ ${moedaRealLocaleValue(params.value)}`,
  //         }, {
  //           field: `ano_Contrato_3`,
  //           headerName: `${tmps.descricao_Ano3}`,
  //           flex: 1,
  //           minWidth: 100,
  //           editable: false,
  //           sortable: UtilidadeService.isMobile() ? false : true,
  //           headerClassName: 'super-app-theme--header',
  //           renderCell: (params) => `R$ ${moedaRealLocaleValue(params.value)}`,
  //         }, {
  //           field: `ano_Contrato_4`,
  //           headerName: `${tmps.descricao_Ano4}`,
  //           flex: 1,
  //           minWidth: 100,
  //           editable: false,
  //           sortable: UtilidadeService.isMobile() ? false : true,
  //           headerClassName: 'super-app-theme--header',
  //           renderCell: (params) => `R$ ${moedaRealLocaleValue(params.value)}`,
  //         }, {
  //           field: `ano_Contrato_5`,
  //           headerName: `${tmps.descricao_Ano5}`,
  //           flex: 1,
  //           minWidth: 100,
  //           editable: false,
  //           sortable: UtilidadeService.isMobile() ? false : true,
  //           headerClassName: 'super-app-theme--header',
  //           renderCell: (params) => `R$ ${moedaRealLocaleValue(params.value)}`,
  //         },
  //       ])
  //     })
  //     .catch((errors) => {
  //       setShowModalMensagem(true);
  //       setRemoveLoading(true);
  //       if (errors.response.status === 401) {
  //         setDadosModalMensagem({
  //           acao: true,
  //           label: "",
  //           tipo: "info",
  //           mensagem: "15- Sessão expirada!",
  //           display: "none",
  //           titulo: "Atenção"
  //         });
  //         logout();
  //         setRedirecionar("0");
  //         return;
  //       }
  //       setDadosModalMensagem({
  //         acao: true,
  //         label: "",
  //         tipo: "error",
  //         mensagem: errors.response.data.mensagem,
  //         display: "none",
  //         titulo: "Atenção"
  //       });
  //     });
  // }

  const toggleModalMensagem = () => {
    setShowModalMensagem(modalVisivel => !modalVisivel);
  }

  const handleSalvarTrocaPosicao = async () => {

    setIsLoading(true);

    if (codigoFranquia === 0 || codigoFranquia === undefined) {
      setShowModalMensagem(true);
      setDadosModalMensagem({
        acao: true,
        label: "",
        tipo: "warning",
        mensagem: "Franquia inválida!",
        display: "none",
        titulo: "Atenção"
      });
      setIsLoading(false);
      return;
    }

    if (codigoJogadorSelecionado === 0 || codigoJogadorSelecionado === undefined) {
      setShowModalMensagem(true);
      setDadosModalMensagem({
        acao: true,
        label: "",
        tipo: "warning",
        mensagem: "Favor selecionar um jogador!",
        display: "none",
        titulo: "Atenção"
      });
      setIsLoading(false);
      return;
    }

    let p1: any = "";
    let p2: any = null;
    let p3: any = null;
    if (posicao1 === 0 || posicao1 === undefined) {
      setShowModalMensagem(true);
      setDadosModalMensagem({
        acao: true,
        label: "",
        tipo: "warning",
        mensagem: "Favor selecionar a posição 1!",
        display: "none",
        titulo: "Atenção"
      });
      setIsLoading(false);
      return;
    }

    const lstPosicao = codigoTipoPosicaoConfronto !== 2 ? lstReferenciasPosicao : lstPosicaoAmericano;
    let dadosSalvar: IDadosSalvarTrocaPosicao = {
      codigo_Franquia: comissarioLiga ? codigoFranquiaContrato : codigoFranquia,
      codigo_Jogador: codigoJogadorSelecionado,
      contundido: chkContundido,
      posicao_1: lstPosicao.find(f => f.codigo === posicao1)?.label ?? p1,
      posicao_2: lstPosicao.find(f => f.codigo === posicao2)?.label ?? p2,
      posicao_3: lstPosicao.find(f => f.codigo === posicao3)?.label ?? p3,
      restrito: chkRestrito,
      fora_NBA: chkForaNba,
      codUsuModificacao: user.codUsuario
    }

    await JogadorService.updatePosicaoJogador(dadosSalvar)
      .then((result) => {
        setIsLoading(false);
        setRemoveLoading(true);
        setShowModalMensagem(true);
        setDadosModalMensagem({
          acao: true,
          label: "",
          tipo: "success",
          mensagem: "Dados atualizados com sucesso!",
          display: "none",
          titulo: "Atenção"
        });
        handleVoltar();
      })
      .catch((errors) => {
        setIsLoading(false);
        setRemoveLoading(true);
        setShowModalMensagem(true);
        if (errors.response !== undefined) {
          if (errors.response.status === 401) {
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: "Sessão expirada!",
              display: "none",
              titulo: "Atenção"
            });
            logout();
            setRedirecionar("0");
            return;
          }
          else {
            setDadosModalMensagem({
              acao: true,
              label: "",
              tipo: "error",
              mensagem: errors.response.data.mensagem,
              display: "none",
              titulo: "Atenção"
            });
            return;
          }
          setDadosModalMensagem({
            acao: true,
            label: "",
            tipo: "error",
            mensagem: "Não foi possível cadastrar os dados do lance! Favor entrar em contato com a TI.",
            display: "none",
            titulo: "Atenção"
          });
        }
      });
  }

  const columnsGeral: GridColDef[] = [
    {
      field: 'codigo_Temporada',
      headerName: '',
      flex: 1,
      minWidth: 58,
      //maxWidth: 58,
      headerClassName: 'super-app-theme--header',
      align: 'center',
      headerAlign: 'center',
      sortable: false,


    },
    {
      field: 'descricao_Temporada',
      headerName: 'TEMP',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 100,
      sortable: false,
      //maxWidth: 60,
      editable: false,
      align: 'center',
      headerAlign: 'center'
    },

    {
      field: 'quantidade_Jogos',
      headerName: 'QTD',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 60,
      sortable: false,
      //maxWidth: 60,
      editable: false,
      align: 'center',
      headerAlign: 'center'
    },
    {
      field: 'minutos',
      headerName: 'MIN',
      editable: false,
      flex: 1,
      minWidth: 60,
      sortable: false,
      //maxWidth: 60,
      headerClassName: 'super-app-theme--header',
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'arremessos',
      headerName: 'FGM',
      editable: false,
      flex: 1,
      minWidth: 60,
      sortable: false,
      //maxWidth: 60,
      headerClassName: 'super-app-theme--header',
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {
      //     if (params.value == null) {
      //         return '';
      //     }
      //     return clsx('super-app', {
      //         negative: parseFloat(fgm.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(fgm.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'lance_Livre',
      headerName: 'FTM',
      editable: false,
      flex: 1,
      minWidth: 60,
      sortable: false,
      //maxWidth: 60,
      headerClassName: 'super-app-theme--header',
      align: 'center',
      headerAlign: 'center',
      hideable: true,
      // cellClassName: (params: GridCellParams<any, number>) => {
      //     if (params.value == null) {
      //         return '';
      //     }
      //     return clsx('super-app', {
      //         negative: parseFloat(fgm.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(fgm.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },

    //   {
    //     field: 'arremessos_Tentativas',
    //     headerName: 'FGM',
    //     editable: false,
    //     flex: 1,
    //     minWidth: 60,
    //     maxWidth: 60,
    //     headerClassName: 'super-app-theme--header',
    //     align: 'center',
    //     headerAlign: 'center',
    //     cellClassName: (params: GridCellParams<any, number>) => {
    //         if (params.value == null) {
    //             return '';
    //         }
    //         return clsx('super-app', {
    //             negative: parseFloat(fga.toString()) < parseFloat(params.value.toString()),
    //             positive: parseFloat(fga.toString()) > parseFloat(params.value.toString()),
    //         });
    //     },
    //renderCell: (params) => params.value !== null ? params.value.toString().toFixed(2) : "0"
    // },
    {
      field: 'tres_Pontos',
      headerName: '3PTS',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 60,
      sortable: false,
      //maxWidth: 60,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {
      //     if (params.value == null) {
      //         return '';
      //     }
      //     return clsx('super-app', {
      //         negative: parseFloat(threepm.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(threepm.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    //   {
    //     field: 'tres_Pontos_Tentativas',
    //     headerName: '3PTST',
    //     editable: false,
    //     headerClassName: 'super-app-theme--header',
    //     flex: 1,
    //     minWidth: 60,
    //     //maxWidth: 60,
    //     align: 'center',
    //     headerAlign: 'center',
    //     cellClassName: (params: GridCellParams<any, number>) => {
    //         if (params.value == null) {
    //             return '';
    //         }
    //         return clsx('super-app', {
    //             negative: parseFloat(threepmp.toString()) < parseFloat(params.value.toString()),
    //             positive: parseFloat(threepmp.toString()) > parseFloat(params.value.toString()),
    //         });
    //     },
    //     renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    // },

    {
      field: 'pontos',
      headerName: 'PTS',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 60,
      sortable: false,
      //maxWidth: 60,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {
      //     if (params.value == null) {
      //         return '';
      //     }
      //     return clsx('super-app', {
      //         negative: parseFloat(pts.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(pts.toString()) > parseFloat(params.value.toString()),
      //         //estatisticasTimeRow !== null && estatisticasTimeRow.find(f=> f) !== null ? estatisticasTimeRow.find(f=> f)?.pts : 0 >= parseFloat(params.value.toString()) ,
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'rebotes',
      headerName: 'REB',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 70,
      sortable: false,
      //maxWidth: 70,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {

      //     if (params.value == null) {

      //         return '';
      //     }

      //     return clsx('super-app', {
      //         negative: parseFloat(reb.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(reb.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'rebotes_Ofensivos',
      headerName: 'OREB',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 70,
      sortable: false,
      //maxWidth: 70,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {

      //     if (params.value == null) {

      //         return '';
      //     }

      //     return clsx('super-app', {
      //         negative: parseFloat(oreb.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(oreb.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'rebotes_Defensivos',
      headerName: 'DREB',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 70,
      sortable: false,
      //maxWidth: 70,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {

      //     if (params.value == null) {

      //         return '';
      //     }

      //     return clsx('super-app', {
      //         negative: parseFloat(dreb.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(dreb.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'assistencias',
      headerName: 'AST',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 70,
      sortable: false,
      //maxWidth: 70,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {

      //     if (params.value == null) {

      //         return '';
      //     }

      //     return clsx('super-app', {
      //         negative: parseFloat(ast.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(ast.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'steal',
      headerName: 'STL',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 60,
      sortable: false,
      //maxWidth: 60,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {

      //     if (params.value == null) {

      //         return '';
      //     }

      //     return clsx('super-app', {
      //         negative: parseFloat(stl.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(stl.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'bloqueios',
      headerName: 'BLK',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 60,
      sortable: false,
      //maxWidth: 60,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {
      //     if (params.value == null) {
      //         return '';
      //     }
      //     return clsx('super-app', {
      //         negative: parseFloat(blk.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(blk.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    //   {
    //     field: 'lance_Livre_Tentativas',
    //     headerName: 'LA',
    //     editable: false,
    //     headerClassName: 'super-app-theme--header',
    //     flex: 1,
    //     minWidth: 60,
    //     maxWidth: 60,
    //     align: 'center',
    //     headerAlign: 'center',
    //     // cellClassName: (params: GridCellParams<any, number>) => {
    //     //     if (params.value == null) {
    //     //         return '';
    //     //     }
    //     //     return clsx('super-app', {
    //     //         negative: parseFloat(blk.toString()) < parseFloat(params.value.toString()),
    //     //         positive: parseFloat(blk.toString()) > parseFloat(params.value.toString()),
    //     //     });
    //     // },
    //     //renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    // },
    {
      field: 'turnovers',
      headerName: 'TO',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 60,
      sortable: false,
      // maxWidth: 60,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {
      //     if (params.value == null) {
      //         return '';
      //     }
      //     return clsx('super-app', {
      //         negative: parseFloat(to.toString()) > parseFloat(params.value.toString()),
      //         positive: parseFloat(to.toString()) < parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'faltas',
      headerName: 'PF',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 60,
      sortable: false,
      //maxWidth: 60,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {
      //     if (params.value == null) {
      //         return '';
      //     }
      //     return clsx('super-app', {
      //         negative: parseFloat(pf.toString()) > parseFloat(params.value.toString()),
      //         positive: parseFloat(pf.toString()) < parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'min_Plus',
      headerName: 'MPLU',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 70,
      sortable: false,
      //maxWidth: 70,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {
      //     if (params.value == null) {
      //         return '';
      //     }
      //     return clsx('super-app', {
      //         negative: parseFloat(mplu.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(mplu.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'porcentagem_Arremessos',
      headerName: 'FGM%',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 70,
      sortable: false,
      //maxWidth: 70,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {
      //     if (params.value == null) {
      //         return '';
      //     }
      //     return clsx('super-app', {
      //         negative: parseFloat(fgmp.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(fgmp.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'porcentagem_Lance_Livre',
      headerName: 'FTM%',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 70,
      sortable: false,
      // maxWidth: 70,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {

      //     if (params.value == null) {

      //         return '';
      //     }

      //     return clsx('super-app', {
      //         negative: parseFloat(ftmp.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(ftmp.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    {
      field: 'porcentagem_Tres_Pontos',
      headerName: '3P%',
      editable: false,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 70,
      sortable: false,
      // maxWidth: 70,
      align: 'center',
      headerAlign: 'center',
      // cellClassName: (params: GridCellParams<any, number>) => {

      //     if (params.value == null) {

      //         return '';
      //     }

      //     return clsx('super-app', {
      //         negative: parseFloat(threepmp.toString()) < parseFloat(params.value.toString()),
      //         positive: parseFloat(threepmp.toString()) > parseFloat(params.value.toString()),
      //     });
      // },
      renderCell: (params) => params.value !== null ? params.value.toFixed(2) : "0"
    },
    // {
    //   field: 'peso_Total_Jogador',
    //   headerName: 'PESO',
    //   editable: false,
    //   headerClassName: 'super-app-theme--header',
    //   flex: 1,
    //   minWidth: 78,
    //   sortable: false,
    //   maxWidth: 78,
    //   align: 'center',
    //   headerAlign: 'center',
    //   cellClassName: (params: GridCellParams<any, number>) => {

    //       if (params.value == null) {

    //           return '';
    //       }

    //       return clsx('super-app', {
    //           negative: params.row.placar_Franquia_Selecionada < params.row.placar_Franquia_Adversaria,
    //           positive: params.row.placar_Franquia_Selecionada > params.row.placar_Franquia_Adversaria,
    //       });
    //   },
    //   renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    // }
  ];

  const handleVoltar = () => {
    voltarPagina === "J" ? navigate("/liga/jogador/todos") :
      voltarPagina === "D" ? navigate(`/usuario/franquia/detalhe/${cryptFranquia} `) :
        navigate("/liga/franquias")
  }

  return (
    <LayoutBaseDePagina
      titulo={`Dados Jogador - ${dadosLiga?.nome}`}
      showLogoImg={dadosLiga?.caminho_Logo !== undefined ? dadosLiga?.caminho_Logo : showImagemLiga}
      barraDeFerramentas={
        <FerramentasDeDetalhe
          mostrarBotaoSalvar={false}
          mostrarBotaoApagar={false}
          mostrarBotaoSalvarEFechar={false}
          mostrarBotaoNovo={false}
          aoClicarEmVoltar={() => handleVoltar()
            //   {
            //   voltarPagina === "J" ? navigate("/liga/jogadores") :
            //     voltarPagina === "D" ? navigate(`/usuario/franquia/detalhe/${cryptFranquia} `) :
            //       navigate("/liga/franquias")
            // }
          }
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave}>
        <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
          {UtilidadeService.isMobile() ?
            (
              <Grid container direction="row" padding={2} spacing={2}>
                <Grid container display="initial" alignItems="center" justifyContent="center" width="100%">
                  <Grid container size={{ xs: 12, sm: 12 }} margin={1} >
                    {(!removeLoading || isLoading) && <Loading />}
                    <Grid size={{ xs: 12 }} spacing={1} display={"flex"} justifyContent={"end"} alignSelf={"flex-end"} paddingLeft={1}>
                      <Typography variant="h6" style={{ fontSize: 14 }}>{dadosTrocaPosicao?.nome_Franquia_Liga}</Typography>
                    </Grid>
                    <Grid container flexDirection={"column"} size={{ xs: 9 }} marginTop={"-5px"} height={"80px"}>
                      <Grid size={{ xs: 4 }} display={"flex"} justifyContent={"center"} marginTop={"-5px"}>
                        <img src={dadosTrocaPosicao?.foto_Jogador}
                          alt="SrcImagem"
                          width={UtilidadeService.isMobile() ? 95 : 200} height={UtilidadeService.isMobile() ? 101 : 200} style={{ borderRadius: "5%" }}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = "../../../../semimagem.png";
                            currentTarget.style.borderRadius = "50%";
                            currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                            currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                          }}
                        />
                      </Grid>
                      <Grid size={{ xs: 8 }} display={"grid"} justifySelf={"start"}  >
                        <Grid size={{ xs: 12 }} spacing={1} display={"flex"} justifySelf={"start"} alignSelf={"end"}>
                          <Typography variant="h6" style={{ fontSize: 16 }}>{dadosTrocaPosicao?.nome_Jogador}</Typography>
                        </Grid>
                        <Grid size={{ xs: 12 }} spacing={1} display={"flex"} alignSelf={"start"} paddingBottom={1}>
                          <Typography variant="body1" style={{ fontSize: 13 }}>{dadosTrocaPosicao?.nome_Franquia_NBA} </Typography>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} marginLeft={1} spacing={1}>
                          <Typography style={{ fontSize: 14 }}>Minutos: {dadosTrocaPosicao?.media_Minutos.toFixed(2).replace(".", ",")}  </Typography>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} marginLeft={1} spacing={1} padding={"8px 0px"}>
                          <Typography style={{ fontSize: 14 }}>Peso Total: {dadosTrocaPosicao?.peso_Total.toFixed(3).replace(".", ",")}  </Typography>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} marginLeft={1} spacing={1} >
                          <Typography style={{ fontSize: 14 }}>FPM: {dadosTrocaPosicao?.peso_Total_Minutos.toFixed(3).replace(".", ",")}  </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    {dadosTrocaPosicao?.nome_Franquia_Liga !== null && (
                      <Grid size={{ xs: 3, sm: 2 }} display="flex" justifyContent="center" >
                        <img src={dadosTrocaPosicao?.logo_Franquia_Liga !== null ? dadosTrocaPosicao?.logo_Franquia_Liga : showImagemFranquia} alt={dadosTrocaPosicao?.nome_Franquia_Liga}
                          width={UtilidadeService.isMobile() ? 60 : 200} height={UtilidadeService.isMobile() ? 66 : 210} />
                      </Grid>
                    )}
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }} paddingTop={2}>
                    <hr />
                  </Grid>
                  <Grid container size={{ xs: 12, sm: 12 }} margin={1}>
                    <Grid size={{ xs: 12, sm: 3 }} spacing={2}>
                      <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 20, fontWeight: 600 }}>TÍTULOS</Typography>
                    </Grid>
                    {listaTitulos.length > 0 && (
                      <Grid size={{ xs: 12, sm: 9 }} spacing={2} >
                        <Grid container key="titulosDivi" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%", }}>
                          {listaTitulos.length > 0 && (listaTitulos.filter(f => f.divisao === true).map(div => (
                            <Grid key={div.codigo} size={{ xs: 1, sm: 1, md: 1 }} display={"grid"} justifyItems={"center"} justifyContent={"center"} textAlign="center" style={{ maxWidth: "82%", margin: "5px" }}>
                              <Card key={div.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                <CardActionArea>
                                  <Tooltip title={`Divisão ${lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label}`}>
                                    <CardMedia
                                      component="img"
                                      alt="Divisão"
                                      height="20"
                                      image={imagemTrofelDivisao}
                                      key={div.codigo}
                                      style={{ width: '100%', padding: 0 }}
                                    />
                                  </Tooltip>
                                </CardActionArea>
                              </Card>
                              <Grid size={{ xs: 12, sm: 3 }} spacing={2}>
                                <Typography variant="h6" style={{ fontSize: 10 }}>{lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label.split("-")[0]}</Typography>
                              </Grid>
                            </Grid>
                          )))
                          }
                        </Grid>
                        <Grid container key="titulosConf" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                          {listaTitulos.length > 0 && (listaTitulos.filter(f => f.conferencia).map(conf => (
                            <Grid key={`GridConf${conf.codigo}`} size={{ xs: 1, sm: 1, md: 1 }} display={"grid"} justifyItems={"center"} justifyContent={"center"} textAlign="center" style={{ maxWidth: "82%" }} >
                              <Card key={`GridConf${conf.codigo}`} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                <CardActionArea>
                                  <Tooltip title={`Conferência ${lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label}`}>
                                    <CardMedia
                                      component="img"
                                      alt="Conferência"
                                      height="20"
                                      image={imagemTrofelConferencia}
                                      key={conf.codigo}
                                      style={{ width: '100%' }}
                                    />
                                  </Tooltip>
                                </CardActionArea>
                              </Card>
                              <Grid size={{ xs: 12, sm: 3 }} spacing={2}>
                                <Typography variant="h6" style={{ fontSize: 10 }}>{lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label.split("-")[0]}</Typography>
                              </Grid>
                            </Grid>
                          )))
                          }
                        </Grid>
                        <Grid container key="titulosLiga" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                          {listaTitulos.length > 0 && (listaTitulos.filter(f => f.liga).map(lig => (
                            <Grid container key="titulosL" size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%" }}>
                              <Grid key={`GridLig${lig.codigo}`} size={{ xs: 1, sm: 1, md: 1 }} display={"grid"} justifyItems={"center"} justifyContent={"center"} textAlign="center" style={{ maxWidth: "82%" }}>
                                <Card key={`CardLig${lig.codigo}`} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                  <CardActionArea>
                                    <Tooltip title={`Liga ${lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label}`}>
                                      <CardMedia
                                        component="img"
                                        alt="Liga"
                                        height="20"
                                        image={imagemTrofelLiga}
                                        key={lig.codigo}
                                        style={{ width: '100%' }}
                                      />
                                    </Tooltip>
                                  </CardActionArea>
                                </Card>
                                <Grid size={{ xs: 12, sm: 3 }} spacing={2}>
                                  <Typography variant="h6" style={{ fontSize: 10 }}>{lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label.split("-")[0]}</Typography>
                                </Grid>
                              </Grid>

                            </Grid>
                          )))
                          }
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                  <Grid container size={{ xs: 12, sm: 12 }} margin={1}>
                    <Grid container size={{ xs: 12, sm: 4 }} >
                      <Grid size={{ xs: 12, sm: 4, md: 4 }} spacing={1} padding={1}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Posição 1</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Posição 1"
                            value={posicao1}
                            onChange={(e) => setPosicao1(Number(e.target.value))}
                            defaultValue={0}
                            disabled={!meuJogador || !aceitaTrocaPosicao}
                            style={{ fontSize: 12, height: 40 }}
                          >
                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                            {
                              listaPosicoes.map(qtd =>
                                <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                              )
                            }
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 4, md: 4 }} spacing={1} padding={1}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Posição 2</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Posição 2"
                            value={posicao2}
                            onChange={(e) => setPosicao2(Number(e.target.value))}
                            defaultValue={0}
                            style={{ fontSize: 12, height: 40 }}
                            disabled={!meuJogador || posicao2 === null || listaPosicoes.length <= 1 || !aceitaTrocaPosicao}
                          >
                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                            {
                              listaPosicoes.map(qtd =>
                                <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                              )
                            }
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 4, md: 4 }} spacing={1} padding={1}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Posição 3</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Posição 3"
                            value={posicao3}
                            onChange={(e) => setPosicao3(Number(e.target.value))}
                            defaultValue={0}
                            style={{ fontSize: 12, height: 40 }}
                            disabled={!meuJogador || posicao3 === null || listaPosicoes.length <= 2 || !aceitaTrocaPosicao}
                          >
                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                            {
                              listaPosicoes.map(qtd =>
                                <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                              )
                            }
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }} spacing={1} padding={1}>
                      <FormControl >
                        <FormControlLabel
                          control={<MuiCheckBox
                            name="chkContundido"
                            checked={chkContundido}
                            onChange={e => { setChkContundido(e.target.checked); }}
                            disabled={!comissarioLiga}

                          />}
                          sx={{ '& .MuiFormControlLabel-label': { fontSize: 12 } }}
                          label="Contundido"
                          labelPlacement="start"
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }} spacing={1} padding={1}>
                      <FormControl>
                        <FormControlLabel
                          control={<MuiCheckBox
                            name="chkRestrito"
                            checked={chkRestrito}
                            onChange={e => setChkRestrito(e.target.checked)}
                            disabled={!comissarioLiga}
                          />}
                          sx={{ '& .MuiFormControlLabel-label': { fontSize: 12 } }}
                          label="Restrito"
                          labelPlacement="start"
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6, md: 6 }} spacing={1} padding={1} >
                      <FormControl>
                        <FormControlLabel
                          control={<MuiCheckBox
                            name="chkForaNba"
                            checked={chkForaNba}
                            onChange={e => setChkForaNba(e.target.checked)}
                            disabled={!comissarioLiga || chkForaNba}
                          />}
                          sx={{ '& .MuiFormControlLabel-label': { fontSize: 12 } }}
                          label="Fora NBA"
                          labelPlacement="start"
                        />
                      </FormControl>
                    </Grid>
                    {meuJogador && (
                      <Grid size={{ xs: 6, sm: 3, md: 2 }} display="flex" alignItems="center" alignSelf={"center"} justifyContent="center" justifyItems="center" textAlign="end">
                        <Button
                          size="small"
                          color="primary"
                          variant="contained"
                          disableElevation
                          onClick={handleSalvarTrocaPosicao}
                          endIcon={<Icon style={{ fontSize: 12, fontWeight: 600 }}>add</Icon>}>
                          Salvar
                        </Button>
                      </Grid>
                    )}
                  </Grid>

                  <Grid container size={{ xs: 12, sm: 12 }}>
                    <Grid size={{ xs: 12, sm: 12 }} margin={1} paddingTop={2}>
                      <Typography variant="h6" style={{ fontSize: 14 }}>CONTRATO</Typography>
                      <hr />
                    </Grid>
                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" paddingLeft={1} >
                      <Grid size={{ xs: 12 }} paddingBottom={1}>
                        <Typography variant="body1" style={{ fontSize: 12, fontWeight: 600 }}>Time</Typography>
                        <Typography variant="body2" style={{ fontSize: 11 }}>{nomeFranquia}</Typography>
                      </Grid>
                      <Grid size={{ xs: 4 }} paddingBottom={1}>
                        <Typography variant="body1" style={{ fontSize: 12, fontWeight: 600 }}>Ano 1</Typography>
                        <Typography variant="body2" style={{ fontSize: 11 }}>{salario1 === "0" ? "R$" + moedaRealLocaleValue(salario1) : "-"}</Typography>
                      </Grid>
                      <Grid size={{ xs: 4 }}  >
                        <Typography variant="body1" style={{ fontSize: 12, fontWeight: 600 }}>Ano 2</Typography>
                        <Typography variant="body2" style={{ fontSize: 11 }}>{salario2 === "0" ? "R$" + moedaRealLocaleValue(salario2) : "-"}</Typography>
                      </Grid>
                      <Grid size={{ xs: 4 }}  >
                        <Typography variant="body1" style={{ fontSize: 12, fontWeight: 600 }}>Ano 3</Typography>
                        <Typography variant="body2" style={{ fontSize: 11 }}>{salario3 === "0" ? "R$" + moedaRealLocaleValue(salario3) : "-"}</Typography>
                      </Grid>
                      <Grid size={{ xs: 4 }}  >
                        <Typography variant="body1" style={{ fontSize: 12, fontWeight: 600 }}>Ano 4</Typography>
                        <Typography variant="body2" style={{ fontSize: 11 }}>{salario4 === "0" ? "R$" + moedaRealLocaleValue(salario4) : "-"}</Typography>
                      </Grid>
                      <Grid size={{ xs: 4 }}  >
                        <Typography variant="body1" style={{ fontSize: 12, fontWeight: 600 }}>Ano 5</Typography>
                        <Typography variant="body2" style={{ fontSize: 11 }}>{salario5 === "0" ? "R$" + moedaRealLocaleValue(salario5) : "-"}</Typography>
                      </Grid>
                    </Grid>
                    {dadosJogadorNBA !== undefined && dadosJogadorNBA.length > 0 && (
                      <Grid size={{ xs: 12, sm: 12 }} margin={1} paddingTop={2}>
                        <Typography variant="h6" style={{ fontSize: 14 }}>MÉDIA NBA</Typography>
                        <hr />
                      </Grid>
                    )}
                    {dadosJogadorNBA !== undefined && dadosJogadorNBA.length > 0 && (
                      <>
                        <Grid size={{ xs: 12, sm: 12 }} >
                          <Box sx={{
                            padding: 0,
                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                            '& .super-app-theme--header': {
                              backgroundColor: theme.palette.common.black,
                              color: theme.palette.common.white
                            },
                            '& .super-app.negative': {
                              color: 'red',
                              fontWeight: 'bold'
                            },
                            '& .super-app.positive': {
                              color: themeName === "light" ? "black" : "auto",
                            },
                          }}>
                            <DataGrid
                              localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                              autoHeight
                              getRowId={(rows) => rows.codigo_Temporada}
                              columnVisibilityModel={{
                                minutos: dadosJogadorNBA.filter(f => f.minutos === null).length === 0,
                                arremessos: dadosJogadorNBA.filter(f => (f.arremessos === null)).length === 0,
                                lance_Livre: dadosJogadorNBA.filter(f => (f.lance_Livre === null)).length === 0,
                                tres_Pontos: dadosJogadorNBA.filter(f => (f.tres_Pontos === null)).length === 0,
                                pontos: dadosJogadorNBA.filter(f => f.pontos === null).length === 0,
                                rebotes: dadosJogadorNBA.filter(f => (f.rebotes === null)).length === 0,
                                rebotes_Ofensivos: dadosJogadorNBA.filter(f => (f.rebotes_Ofensivos === null)).length === 0,
                                rebotes_Defensivos: dadosJogadorNBA.filter(f => (f.rebotes_Defensivos === null)).length === 0,
                                assistencias: dadosJogadorNBA.filter(f => (f.assistencias === null)).length === 0,
                                steal: dadosJogadorNBA.filter(f => (f.steal === null)).length === 0,
                                bloqueios: dadosJogadorNBA.filter(f => (f.bloqueios === null)).length === 0,
                                turnovers: dadosJogadorNBA.filter(f => (f.turnovers === null)).length === 0,
                                faltas: dadosJogadorNBA.filter(f => (f.faltas === null)).length === 0,
                                min_Plus: dadosJogadorNBA.filter(f => (f.min_Plus === null)).length === 0,
                                porcentagem_Arremessos: dadosJogadorNBA.filter(f => (f.porcentagem_Arremessos === null)).length === 0,
                                porcentagem_Lance_Livre: dadosJogadorNBA.filter(f => (f.porcentagem_Lance_Livre === null)).length === 0,
                                porcentagem_Tres_Pontos: dadosJogadorNBA.filter(f => (f.porcentagem_Tres_Pontos === null)).length === 0,
                                peso_Total_Jogador: dadosJogadorNBA.filter(f => (f.peso_Total_Jogador === null)).length === 0,
                                //: dadosJogadorNBA.filter(f => (f.threepmp === null)).length === 0,
                                //     : dadosJogadorNBA.filter(f => (f.to === null)).length === 0,
                              }
                              }
                              rows={dadosJogadorNBA}
                              columns={columnsGeral}
                              initialState={{
                                pagination: {
                                  paginationModel: {
                                    pageSize: 12,
                                  },
                                },
                              }}
                              pageSizeOptions={[12]}
                              //checkboxSelection
                              disableRowSelectionOnClick
                              disableColumnFilter
                              disableColumnMenu
                              hideFooter={true}
                              sx={{
                                fontSize: 10,
                              }}
                            />
                          </Box>
                        </Grid>
                      </>
                    )}

                    {dadosJogadorLiga !== undefined && dadosJogadorLiga.length > 0 && (
                      <Grid size={{ xs: 12, sm: 12 }} margin={1} paddingTop={2}>
                        <Typography variant="h6" style={{ fontSize: 14 }}>MÉDIA LIGA</Typography>
                        <hr />
                      </Grid>
                    )}
                    {dadosJogadorLiga !== undefined && dadosJogadorLiga.length > 0 && (
                      <>
                        <Grid size={{ xs: 12, sm: 12 }} >
                          <Box sx={{
                            padding: 0,
                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                            '& .super-app-theme--header': {
                              backgroundColor: theme.palette.common.black,
                              color: theme.palette.common.white
                            },
                            '& .super-app.negative': {
                              color: 'red',
                              fontWeight: 'bold'
                            },
                            '& .super-app.positive': {
                              color: themeName === "light" ? "black" : "auto",
                            },
                          }}>
                            <DataGrid
                              localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                              autoHeight
                              getRowId={(rows) => rows.codigo_Temporada}
                              columnVisibilityModel={{
                                minutos: dadosJogadorLiga.filter(f => f.minutos === null || f.minutos === 0).length === 0,
                                arremessos: dadosJogadorLiga.filter(f => (f.arremessos === null || f.arremessos === 0)).length === 0,
                                lance_Livre: dadosJogadorLiga.filter(f => (f.lance_Livre === null || f.lance_Livre === 0)).length === 0,
                                tres_Pontos: dadosJogadorLiga.filter(f => (f.tres_Pontos === null || f.tres_Pontos === 0)).length === 0,
                                pontos: dadosJogadorLiga.filter(f => f.pontos === null || f.pontos === 0).length === 0,
                                rebotes: dadosJogadorLiga.filter(f => (f.rebotes === null || f.rebotes === 0)).length === 0,
                                rebotes_Ofensivos: dadosJogadorLiga.filter(f => (f.rebotes_Ofensivos === null || f.rebotes_Ofensivos === 0)).length === 0,
                                rebotes_Defensivos: dadosJogadorLiga.filter(f => (f.rebotes_Defensivos === null || f.rebotes_Defensivos === 0)).length === 0,
                                assistencias: dadosJogadorLiga.filter(f => (f.assistencias === null || f.assistencias === 0)).length === 0,
                                steal: dadosJogadorLiga.filter(f => (f.steal === null || f.steal === 0)).length === 0,
                                bloqueios: dadosJogadorLiga.filter(f => (f.bloqueios === null || f.bloqueios === 0)).length === 0,
                                turnovers: dadosJogadorLiga.filter(f => (f.turnovers === null || f.turnovers === 0)).length === 0,
                                faltas: dadosJogadorLiga.filter(f => (f.faltas === null || f.faltas === 0)).length === 0,
                                min_Plus: dadosJogadorLiga.filter(f => (f.min_Plus === null || f.min_Plus === 0)).length === 0,
                                porcentagem_Arremessos: dadosJogadorLiga.filter(f => (f.porcentagem_Arremessos === null || f.porcentagem_Arremessos === 0)).length === 0,
                                porcentagem_Lance_Livre: dadosJogadorLiga.filter(f => (f.porcentagem_Lance_Livre === null || f.porcentagem_Lance_Livre === 0)).length === 0,
                                porcentagem_Tres_Pontos: dadosJogadorLiga.filter(f => (f.porcentagem_Tres_Pontos === null || f.porcentagem_Tres_Pontos === 0)).length === 0,
                                //peso_Total_Jogador: dadosJogadorLiga.filter(f => (f.peso_Total_Jogador === null || f.peso_Total_Jogador === 0)).length === 0,
                                //:  dadosJogadorLiga.filter(f => (f.threepmp === null)).length === 0,
                                //     :  dadosJogadorLiga.filter(f => (f.to === null)).length === 0,
                              }
                              }
                              rows={dadosJogadorLiga}
                              columns={columnsGeral}
                              initialState={{
                                pagination: {
                                  paginationModel: {
                                    pageSize: 100,
                                  },
                                },
                              }}
                              pageSizeOptions={[100]}
                              //checkboxSelection
                              disableRowSelectionOnClick
                              disableColumnFilter
                              disableColumnMenu
                              hideFooter={true}
                              sx={{
                                fontSize: 10,
                              }}
                            />
                          </Box>
                        </Grid>
                      </>
                    )}

                  </Grid>
                  <Grid container size={{ xs: 12, sm: 12 }} margin={1} paddingTop={2}>
                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" direction="row" >
                      <Grid size={{ xs: 12, sm: 12 }} >
                        <Typography variant="h6" style={{ fontSize: 14 }}>HISTÓRICO LIGA</Typography>
                        <hr />
                        {(!removeLoading || isLoading) && <Loading />}
                      </Grid>
                      <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                        {!isLoading && lstDadosHistorico.length > 0 && (
                          lstDadosHistorico.map((hist, i) => (
                            <Grid key={`Grid ${i}`} size={{ xs: 12, sm: 12, md: 12 }}   >
                              <Grid  >
                                <Box width="100%" display="flex" flexDirection="row" justifySelf="center" alignSelf="center">
                                  <Grid size={{ xs: 12, sm: 12 }} display="flex" justifyContent="start" flexDirection="column">
                                    <Typography variant="body1" style={{ fontSize: 11 }} sx={{ paddingLeft: "10px" }} display="flex" alignSelf="center">
                                      {hist.descricao}
                                    </Typography>
                                  </Grid>
                                </Box>
                              </Grid>
                            </Grid>
                          )))}
                      </Grid>
                    </Grid>
                  </Grid>
                  {ultimosContratosRows.length > 0 && (
                    <>
                      <Grid container size={{ xs: 12, sm: 12 }} margin={1} paddingTop={2}>
                        <Grid size={{ xs: 12, sm: 12 }} >
                          <Typography variant="h6" style={{ fontSize: 14 }}>ÚLTIMOS CONTRATOS LIGA</Typography>
                          <hr />
                          {!removeLoading && <Loading />}
                        </Grid>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} width={"100%"}>
                        <Box sx={{
                          height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                          '& .super-app-theme--header': {
                            backgroundColor: theme.palette.common.black,
                            color: theme.palette.common.white
                          },
                          '& .super-app.negative': {
                            color: 'red',
                            fontWeight: 'bold'
                          },
                          '& .super-app.positive': {
                            color: themeName === "light" ? "black" : "auto",
                          },
                        }}>
                          <DataGrid
                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                            autoHeight
                            getRowId={(rows) => rows.codigo}
                            rows={ultimosContratosRows}
                            columns={columnsContratos}
                            initialState={{
                              pagination: {
                                paginationModel: {
                                  pageSize: 100,
                                },
                              },
                            }}
                            pageSizeOptions={[100]}
                            //checkboxSelection
                            disableRowSelectionOnClick
                            disableColumnFilter
                            disableColumnMenu
                            hideFooter={true}
                            sx={{
                              fontSize: 10,
                            }}
                          />
                        </Box>
                      </Grid>
                    </>)}
                </Grid>
              </Grid >
            ) :
            (
              <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2}>
                <Grid container size={{ xs: 12, sm: 12 }} display="initial" alignItems="center" justifyContent="center" width="100%">
                  <Grid container size={{ xs: 12, sm: 12 }} margin={1}>
                    <Grid size={{ xs: 12, sm: 2 }} >
                      <img src={dadosTrocaPosicao?.foto_Jogador}
                        alt="SrcImagem"
                        width="200" height="190" style={{ borderRadius: "5%" }}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = "../../../../semimagem.png";
                          currentTarget.style.borderRadius = "50%";
                          currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                          currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                        }}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }} spacing={1} >
                      <Typography variant="h5">{dadosTrocaPosicao?.nome_Jogador}</Typography>
                      <Typography style={{ fontSize: 16 }}>{dadosTrocaPosicao?.nome_Franquia_NBA} </Typography>
                      <hr />
                      <Grid container size={{ xs: 12, sm: 12 }} marginLeft={1} spacing={1}>
                        <Typography style={{ fontSize: 14 }}>Minutos: {dadosTrocaPosicao?.media_Minutos.toFixed(2).replace(".", ",")}  </Typography>
                      </Grid>
                      <Grid container size={{ xs: 12, sm: 12 }} marginLeft={1} spacing={1} padding={"8px 0px"}>
                        <Typography style={{ fontSize: 14 }}>Peso Total: {dadosTrocaPosicao?.peso_Total.toFixed(3).replace(".", ",")}  </Typography>
                      </Grid>
                      <Grid container size={{ xs: 12, sm: 12 }} marginLeft={1} spacing={1} >
                        <Typography style={{ fontSize: 14 }}>FPM: {dadosTrocaPosicao?.peso_Total_Minutos.toFixed(3).replace(".", ",")}  </Typography>
                      </Grid>

                      {/* <Typography style={{ fontSize: 14 }}>Peso Total: 19,971 </Typography>
                      <Typography style={{ fontSize: 14 }}>FPM: 0,782</Typography> */}
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }} spacing={1} >
                      <Typography variant="h6">{dadosTrocaPosicao?.nome_Franquia_Liga}</Typography>
                      <Grid size={{ xs: 12, sm: 3 }} spacing={2}>
                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 18, fontWeight: 600 }}>TÍTULOS</Typography>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 9 }} spacing={2} >
                        <Grid container key="titulosD" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%", }}>
                          {listaTitulos.length > 0 && (listaTitulos.filter(f => f.divisao === true).map(div => (
                            <Grid key={div.codigo} size={{ xs: 1, sm: 1, md: 1 }} display={"grid"} justifyItems={"center"} justifyContent={"center"} textAlign="center" style={{ maxWidth: "82%", margin: "5px" }}>
                              <Card key={div.codigo} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                <CardActionArea>
                                  <Tooltip title={`Divisão ${lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label} - ${div.nome_Franquia}`}>
                                    <CardMedia
                                      component="img"
                                      alt="Divisão"
                                      height="35"
                                      image={imagemTrofelDivisao}
                                      key={div.codigo}
                                      style={{ width: '100%', padding: 0 }}
                                    />
                                  </Tooltip>
                                </CardActionArea>
                              </Card>
                              <Grid size={{ xs: 12, sm: 12 }} spacing={2}>
                                <Typography variant="h6" style={{ fontSize: 14 }}>{lstTemporadas.find(f => f.codigo === div.codigo_Temporada)?.label.split("-")[0]}</Typography>
                              </Grid>
                            </Grid>
                          )))
                          }
                        </Grid>
                        <Grid container key="titulosC" paddingBottom={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%", paddingLeft: "5px" }}>
                          {listaTitulos.length > 0 && (listaTitulos.filter(f => f.conferencia === true).map(conf => (
                            <Grid key={`GridConf${conf.codigo}`} size={{ xs: 1, sm: 1, md: 1 }} display={"grid"} justifyItems={"center"} justifyContent={"center"} textAlign="center" style={{ maxWidth: "82%" }} >
                              <Card key={`GridConf${conf.codigo}`} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                <CardActionArea>
                                  <Tooltip title={`Conferência ${lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label} - ${conf.nome_Franquia}`}>
                                    <CardMedia
                                      component="img"
                                      alt="Conferência"
                                      height="40"
                                      image={imagemTrofelConferencia}
                                      key={conf.codigo}
                                      style={{ width: '100%' }}
                                    />
                                  </Tooltip>
                                </CardActionArea>
                              </Card>
                              <Grid size={{ xs: 12, sm: 12 }} spacing={2}>
                                <Typography variant="h6" style={{ fontSize: 14 }}>{lstTemporadas.find(f => f.codigo === conf.codigo_Temporada)?.label.split("-")[0]}</Typography>
                              </Grid>
                            </Grid>
                          )))
                          }
                        </Grid>
                        {listaTitulos.length > 0 && (listaTitulos.filter(f => f.liga === true).map(lig => (
                          <Grid container key="titulosL" size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" style={{ maxWidth: "100%", paddingLeft: "5px" }}>
                            <Grid key={`GridLig${lig.codigo}`} size={{ xs: 1, sm: 1, md: 1 }} display={"grid"} justifyItems={"center"} justifyContent={"center"} textAlign="center" style={{ maxWidth: "82%" }}>
                              <Card key={`CardLig${lig.codigo}`} sx={{ backgroundImage: "none", boxShadow: "none" }}>
                                <CardActionArea>
                                  <Tooltip title={`Liga ${lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label} - ${lig.nome_Franquia}`}>
                                    <CardMedia
                                      component="img"
                                      alt="Liga"
                                      height="35"
                                      image={imagemTrofelLiga}
                                      key={lig.codigo}
                                      style={{ width: '100%' }}
                                    />
                                  </Tooltip>
                                </CardActionArea>
                              </Card>
                              <Grid size={{ xs: 12, sm: 12 }} spacing={2}>
                                <Typography variant="h6" style={{ fontSize: 14 }}>{lstTemporadas.find(f => f.codigo === lig.codigo_Temporada)?.label.split("-")[0]}</Typography>
                              </Grid>
                            </Grid>

                          </Grid>
                        )))
                        }
                      </Grid>
                    </Grid>
                    {dadosTrocaPosicao?.nome_Franquia_Liga !== null && (
                      <Grid size={{ xs: 12, sm: 2 }} display="flex" justifyContent="end" >
                        <img src={dadosTrocaPosicao?.logo_Franquia_Liga !== null ? dadosTrocaPosicao?.logo_Franquia_Liga : showImagemFranquia} alt={dadosTrocaPosicao?.nome_Franquia_Liga} width="200" height="210" />

                      </Grid>
                    )}
                  </Grid>
                  <Grid container size={{ xs: 12, sm: 12 }} margin={1}>
                    <Grid size={{ xs: 12, sm: 12 }} >
                      <hr />
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 12, sm: 12 }} margin={1}>
                    <Grid container size={{ xs: 12, sm: 4 }} >
                      <Grid size={{ xs: 12, sm: 4, md: 4 }} spacing={1} padding={1}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Posição 1</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Posição 1"
                            value={posicao1}
                            onChange={(e) => setPosicao1(Number(e.target.value))}
                            defaultValue={0}
                            disabled={!meuJogador || !aceitaTrocaPosicao}
                          >
                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                            {
                              listaPosicoes.map(qtd =>
                                <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                              )
                            }
                          </Select>
                        </FormControl>

                      </Grid>
                      <Grid size={{ xs: 12, sm: 4, md: 4 }} spacing={1} padding={1}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Posição 2</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Posição 2"
                            value={posicao2}
                            onChange={(e) => setPosicao2(Number(e.target.value))}
                            defaultValue={0}
                            disabled={!meuJogador || posicao2 === null || listaPosicoes.length <= 1 || !aceitaTrocaPosicao}
                          >
                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                            {
                              listaPosicoes.map(qtd =>
                                <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                              )
                            }
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 4, md: 4 }} spacing={1} padding={1}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Posição 3</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Posição 3"
                            value={posicao3}
                            onChange={(e) => setPosicao3(Number(e.target.value))}
                            defaultValue={0}
                            disabled={!meuJogador || posicao3 === null || listaPosicoes.length <= 2 || !aceitaTrocaPosicao}
                          >
                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                            {
                              listaPosicoes.map(qtd =>
                                <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                              )
                            }
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 3, md: 2 }} spacing={1} padding={1}>
                      <FormControl>
                        <FormControlLabel
                          control={<MuiCheckBox
                            name="chkContundido"
                            checked={chkContundido}
                            onChange={e => { setChkContundido(e.target.checked); }}
                            disabled={!comissarioLiga || disableContundido}
                          />}
                          label="Contundido"
                          labelPlacement="start"
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 3, md: 2 }} spacing={1} padding={1}>
                      <FormControl>
                        <FormControlLabel
                          control={<MuiCheckBox
                            name="chkRestrito"
                            checked={chkRestrito}
                            onChange={e => setChkRestrito(e.target.checked)}
                            disabled={!comissarioLiga}
                          />}
                          label="Restrito"
                          labelPlacement="start"
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 3, md: 2 }} spacing={1} padding={1}>
                      <FormControl>
                        <FormControlLabel
                          control={<MuiCheckBox
                            name="chkForaNba"
                            checked={chkForaNba}
                            onChange={e => setChkForaNba(e.target.checked)}
                            disabled={!comissarioLiga || disableForaNba}
                          />}
                          label="Fora NBA"
                          labelPlacement="start"
                        />
                      </FormControl>
                    </Grid>
                    {meuJogador && (
                      <Grid size={{ xs: 12, sm: 3, md: 2 }} display="flex" alignItems="center" justifyContent="start" justifyItems="center" textAlign="end">
                        <Button
                          color="primary"
                          variant="contained"
                          disableElevation
                          onClick={handleSalvarTrocaPosicao}
                          endIcon={<Icon>add</Icon>}>
                          Salvar
                        </Button>
                      </Grid>
                    )}
                  </Grid>

                  <Grid container size={{ xs: 12, sm: 12 }}>
                    <Grid size={{ xs: 12, sm: 12 }} margin={1} paddingTop={2}>
                      <Typography variant="h6">CONTRATO ATUAL</Typography>
                      <hr />
                    </Grid>
                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyItems="center" paddingLeft={2} >
                      <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                        <Typography variant="body1">Time</Typography>
                        <Typography variant="body2">{nomeFranquia}</Typography>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                        <Typography variant="body1">Ano 1</Typography>
                        <Typography variant="body2">{salario1 === "0" ? "R$" + moedaRealLocaleValue(salario1) : "-"}</Typography>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                        <Typography variant="body1">Ano 2</Typography>
                        <Typography variant="body2">{salario2 === "0" ? "R$" + moedaRealLocaleValue(salario2) : "-"}</Typography>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                        <Typography variant="body1">Ano 3</Typography>
                        <Typography variant="body2">{salario3 === "0" ? "R$" + moedaRealLocaleValue(salario3) : "-"}</Typography>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                        <Typography variant="body1">Ano 4</Typography>
                        <Typography variant="body2">{salario4 === "0" ? "R$" + moedaRealLocaleValue(salario4) : "-"}</Typography>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                        <Typography variant="body1">Ano 5</Typography>
                        <Typography variant="body2">{salario5 === "0" ? "R$" + moedaRealLocaleValue(salario5) : "-"}</Typography>
                      </Grid>
                    </Grid>
                    {dadosJogadorNBA !== undefined && dadosJogadorNBA.length > 0 && (
                      <Grid size={{ xs: 12, sm: 12 }} margin={1} paddingTop={2}>
                        <Typography variant="h6">MÉDIA NBA</Typography>
                        <hr />
                      </Grid>
                    )}
                    {dadosJogadorNBA !== undefined && dadosJogadorNBA.length > 0 && (dadosJogadorNBACab.map((nba, i) => (
                      <Grid container size={{ xs: 12, sm: 12 }} key={`CabNba${i}`} marginLeft={1} spacing={1} display="flex" justifyItems="center" >
                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} spacing={2}>
                          {nba?.descricao_Temporada !== null && nba?.descricao_Temporada !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Temporada" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">ANO</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.arremessos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Arremessos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">FGM</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.arremessos_Tentativas !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Arremessos Tentativas" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">FGA</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.lance_Livre !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Lance Livre" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">FTM</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.lance_Livre_Tentativas !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Lance Livre Tentativas" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">FTA</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.tres_Pontos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Três Pontos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">3PM</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.tres_Pontos_Tentativas !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Três Pontos Tentativas" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">3PA</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.pontos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Pontos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">PTS</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.rebotes !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Rebotes" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">REB</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.rebotes_Ofensivos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Rebotes" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">OREB</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.rebotes_Defensivos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body1"></Typography>
                              <Tooltip title="Rebotes Defensivos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">DREB</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.assistencias !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Assistências" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">AST</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.steal !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Roubo de Bola (steal)" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">STL</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.bloqueios !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Bloqueios" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">BLK</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.turnovers !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Turn Overs" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">TO</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.faltas !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Faltas" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">PF</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.porcentagem_Arremessos !== null && nba?.porcentagem_Arremessos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="% Arremessos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">FG%</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.porcentagem_Lance_Livre !== null && nba?.porcentagem_Lance_Livre !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="% Lance Livre" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">FT%</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.porcentagem_Tres_Pontos !== null && nba?.porcentagem_Tres_Pontos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="% Três Pontos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">3P%</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.min_Plus !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Min Plus" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">MIN PLUS</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.minutos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Minutos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">MIN</Typography></Tooltip>
                            </Grid>
                          }
                          {nba?.quantidade_Jogos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Quantidade de Jogos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">QTD. JOG.</Typography></Tooltip>
                            </Grid>
                          }
                          {/* {nba?.peso_Total_Jogador !== null && nba?.peso_Total_Jogador !== undefined && 
                          <Grid size={{xs:12, sm:4, md:1}} >
                            <Tooltip title="Total" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">TOTAL</Typography></Tooltip>
                          </Grid>
                        } */}
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12 }} style={{ paddingTop: "0px", paddingRight: "10px" }}>
                          <hr />
                        </Grid>
                      </Grid>
                    ))
                    )}
                    {dadosJogadorNBA !== undefined && dadosJogadorNBA.length > 0 && (dadosJogadorNBA.map((nba, i) => (
                      <Grid container size={{ xs: 12, sm: 12 }} key={`DadosNba${i}`} margin={1} spacing={1} display="flex" justifyItems="center" >
                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} paddingBottom={1} paddingTop={1} spacing={2}>
                          {nba?.descricao_Temporada !== null && nba?.descricao_Temporada !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.descricao_Temporada}</Typography>
                            </Grid>
                          }
                          {nba?.arremessos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.arremessos !== 0 ? nba?.arremessos.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.arremessos_Tentativas !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.arremessos_Tentativas !== 0 ? nba?.arremessos_Tentativas.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.lance_Livre !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.lance_Livre !== 0 ? nba?.lance_Livre.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.lance_Livre_Tentativas !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.lance_Livre_Tentativas !== 0 ? nba?.lance_Livre_Tentativas.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.tres_Pontos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.tres_Pontos !== 0 ? nba?.tres_Pontos.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.tres_Pontos_Tentativas !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.tres_Pontos_Tentativas !== 0 ? nba?.tres_Pontos_Tentativas.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.pontos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.pontos !== 0 ? nba?.pontos.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.rebotes !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.rebotes !== 0 ? nba?.rebotes.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.rebotes_Ofensivos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.rebotes_Ofensivos !== 0 ? nba?.rebotes_Ofensivos.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.rebotes_Defensivos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.rebotes_Defensivos !== 0 ? nba?.rebotes_Defensivos.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.assistencias !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.assistencias !== 0 ? nba?.assistencias.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.steal !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.steal !== 0 ? nba?.steal.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.bloqueios !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.bloqueios !== 0 ? nba?.bloqueios.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.turnovers !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.turnovers !== 0 ? nba?.turnovers.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.faltas !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.faltas !== 0 ? nba?.faltas.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.porcentagem_Arremessos !== null && nba?.porcentagem_Arremessos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.porcentagem_Arremessos !== 0 ? nba?.porcentagem_Arremessos.toFixed(3).toString().replace(".", ",") : ""}</Typography>
                            </Grid>
                          }
                          {nba?.porcentagem_Lance_Livre !== null && nba?.porcentagem_Lance_Livre !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.porcentagem_Lance_Livre !== 0 ? nba?.porcentagem_Lance_Livre.toFixed(3).toString().replace(".", ",") : ""}</Typography>
                            </Grid>
                          }
                          {nba?.porcentagem_Tres_Pontos !== null && nba?.porcentagem_Tres_Pontos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.porcentagem_Tres_Pontos !== 0 ? nba?.porcentagem_Tres_Pontos.toFixed(3).toString().replace(".", ",") : ""}</Typography>
                            </Grid>
                          }
                          {nba?.min_Plus !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.min_Plus !== 0 ? nba?.min_Plus.toFixed(0) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.minutos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.minutos !== 0 ? nba?.minutos.toFixed(0) : ""}</Typography>
                            </Grid>
                          }
                          {nba?.quantidade_Jogos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{nba?.quantidade_Jogos !== 0 ? nba?.quantidade_Jogos.toFixed(0).toString().replace(".", ",") : ""}</Typography>
                            </Grid>
                          }
                          {/* {nba?.peso_Total_Jogador !== null && nba?.peso_Total_Jogador !== undefined && nba?.peso_Total_Jogador !== 0 &&
                          <Grid size={{xs:12, sm:4, md:1}} >
                            <Typography variant="body2">{nba?.peso_Total_Jogador.toFixed(3).toString().replace(".", ",")}</Typography>
                          </Grid>
                        } */}
                        </Grid>
                      </Grid>
                    ))
                    )}

                    {dadosJogadorLiga !== undefined && dadosJogadorLiga.length > 0 && (
                      <Grid size={{ xs: 12, sm: 12 }} margin={1} paddingTop={2}>
                        <Typography variant="h6">MÉDIA LIGA</Typography>
                        <hr />
                      </Grid>
                    )}
                    {dadosJogadorLiga !== undefined && dadosJogadorLiga.length > 0 && (dadosJogadorLiga.slice(0, 1).map((liga, i) => (
                      <Grid container size={{ xs: 12, sm: 12 }} key={`CabLiga${i}`} marginLeft={1} spacing={1} display="flex" justifyItems="center" >
                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} spacing={2} >
                          {liga?.descricao_Temporada !== null && liga?.descricao_Temporada !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Temporada" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">ANO</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.arremessos !== null && liga?.arremessos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Arremessos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">FGM</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.arremessos_Tentativas !== null && liga?.arremessos_Tentativas !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Arremessos Tentativas" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">FGA</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.lance_Livre !== null && liga?.lance_Livre !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Lance Livre" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">FTM</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.lance_Livre_Tentativas !== null && liga?.lance_Livre_Tentativas !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Lance Livre Tentativas" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">FTA</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.tres_Pontos !== null && liga?.tres_Pontos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Três Pontos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">3PM</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.tres_Pontos_Tentativas !== null && liga?.tres_Pontos_Tentativas !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Três Pontos Tentativas" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">3PA</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.pontos !== null && liga?.pontos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Pontos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">PTS</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.rebotes !== null && liga?.rebotes !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Rebotes" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">REB</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.rebotes_Ofensivos !== null && liga?.rebotes_Ofensivos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Rebotes" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">OREB</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.rebotes_Defensivos !== null && liga?.rebotes_Defensivos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Rebotes Defensivos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">DREB</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.assistencias !== null && liga?.assistencias !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Assistências" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">AST</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.steal !== null && liga?.steal !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Roubo de Bola (steal)" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">STL</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.bloqueios !== null && liga?.bloqueios !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Bloqueios" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">BLK</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.turnovers !== null && liga?.turnovers !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Turn Overs" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">TO</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.faltas !== null && liga?.faltas !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Faltas" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">PF</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.porcentagem_Arremessos !== null && liga?.porcentagem_Arremessos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="% Arremessos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">FG%</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.porcentagem_Lance_Livre !== null && liga?.porcentagem_Lance_Livre !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="% Lance Livre" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">FT%</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.porcentagem_Tres_Pontos !== null && liga?.porcentagem_Tres_Pontos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="% Três Pontos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">3P%</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.min_Plus !== null && liga?.min_Plus !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Min Plus" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">MIN PLUS</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.minutos !== null && liga?.minutos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Minutos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">MIN</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.quantidade_Jogos !== null && liga?.quantidade_Jogos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Quantidade de Jogos" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">QTD. JOG.</Typography></Tooltip>
                            </Grid>
                          }
                          {liga?.peso_Total_Jogador !== null && liga?.peso_Total_Jogador !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Tooltip title="Total" placement="top"><Typography sx={{ fontWeight: "bold" }} variant="body1">TOTAL</Typography></Tooltip>
                            </Grid>
                          }
                          <Grid size={{ xs: 12, sm: 12, md: 12 }} style={{ paddingTop: "0px", paddingRight: "10px" }}>
                            <hr />
                          </Grid>
                        </Grid>
                      </Grid>
                    ))
                    )}
                    {dadosJogadorLiga !== undefined && dadosJogadorLiga.length > 0 && (dadosJogadorLiga.map((liga, i) => (
                      <Grid container size={{ xs: 12, sm: 12 }} key={`DadosLiga${i}`} margin={1} spacing={1} display="flex" justifyItems="center"  >
                        <Grid container size={{ xs: 12, sm: 6, md: 12 }} spacing={2}>
                          {liga?.descricao_Temporada !== null && liga?.descricao_Temporada !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.descricao_Temporada}</Typography>
                            </Grid>
                          }
                          {liga?.arremessos !== null && liga?.arremessos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.arremessos !== 0 ? liga?.arremessos.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.arremessos_Tentativas !== null && liga?.arremessos_Tentativas !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.arremessos_Tentativas !== 0 ? liga?.arremessos_Tentativas.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.lance_Livre !== null && liga?.lance_Livre !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.lance_Livre !== 0 ? liga?.lance_Livre.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.lance_Livre_Tentativas !== null && liga?.lance_Livre_Tentativas !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.lance_Livre_Tentativas !== 0 ? liga?.lance_Livre_Tentativas.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.tres_Pontos !== null && liga?.tres_Pontos !== 0 &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.tres_Pontos !== 0 ? liga?.tres_Pontos.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.tres_Pontos_Tentativas !== null && liga?.tres_Pontos_Tentativas !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.tres_Pontos_Tentativas !== 0 ? liga?.tres_Pontos_Tentativas.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.pontos !== null &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.pontos !== 0 ? liga?.pontos.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.rebotes !== null && liga?.rebotes !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.rebotes !== 0 ? liga?.rebotes.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.rebotes_Ofensivos !== null && liga?.rebotes_Ofensivos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.rebotes_Ofensivos !== 0 ? liga?.rebotes_Ofensivos.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.rebotes_Defensivos !== null && liga?.rebotes_Defensivos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.rebotes_Defensivos !== 0 ? liga?.rebotes_Defensivos.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.assistencias !== null && liga?.assistencias !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.assistencias !== 0 ? liga?.assistencias.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.steal !== null && liga?.steal !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.steal !== 0 ? liga?.steal.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.bloqueios !== null && liga?.bloqueios !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.bloqueios !== 0 ? liga?.bloqueios.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.turnovers !== null && liga?.turnovers !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.turnovers !== 0 ? liga?.turnovers.toFixed(2) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.faltas !== null && liga?.faltas !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.faltas !== 0 ? liga?.faltas : ""}</Typography>
                            </Grid>
                          }
                          {liga?.porcentagem_Arremessos !== null && liga?.porcentagem_Arremessos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.porcentagem_Arremessos !== 0 ? liga?.porcentagem_Arremessos.toFixed(3).toString().replace(".", ",") : ""}</Typography>
                            </Grid>
                          }
                          {liga?.porcentagem_Lance_Livre !== null && liga?.porcentagem_Lance_Livre !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.porcentagem_Lance_Livre !== 0 ? liga?.porcentagem_Lance_Livre.toFixed(3).toString().replace(".", ",") : ""}</Typography>
                            </Grid>
                          }
                          {liga?.porcentagem_Tres_Pontos !== null && liga?.porcentagem_Tres_Pontos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.porcentagem_Tres_Pontos !== 0 ? liga?.porcentagem_Tres_Pontos.toFixed(3).toString().replace(".", ",") : ""}</Typography>
                            </Grid>
                          }
                          {liga?.min_Plus !== null && liga?.min_Plus !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.min_Plus !== 0 ? liga?.min_Plus.toFixed(0) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.minutos !== null && liga?.minutos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.minutos !== 0 ? liga?.minutos.toFixed(0) : ""}</Typography>
                            </Grid>
                          }
                          {liga?.quantidade_Jogos !== null && liga?.quantidade_Jogos !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.quantidade_Jogos !== 0 ? liga?.quantidade_Jogos.toFixed(0).toString().replace(".", ",") : ""}</Typography>
                            </Grid>
                          }
                          {liga?.peso_Total_Jogador !== null && liga?.peso_Total_Jogador !== undefined &&
                            <Grid size={{ xs: 12, sm: 4, md: 1 }} >
                              <Typography variant="body2">{liga?.peso_Total_Jogador !== 0 ? liga?.peso_Total_Jogador.toFixed(3).toString().replace(".", ",") : ""}</Typography>
                            </Grid>
                          }
                        </Grid>
                      </Grid>
                    ))
                    )}
                  </Grid>
                  <Grid container size={{ xs: 12, sm: 12 }} margin={1} paddingTop={2}>
                    <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="center" direction="row" >
                      <Grid size={{ xs: 12, sm: 12 }} >
                        <Typography variant="h6">HISTÓRICO LIGA</Typography>
                        <hr />
                        {!removeLoading && <Loading />}
                      </Grid>
                      <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                        {!isLoading && lstDadosHistorico.length > 0 && (
                          lstDadosHistorico.map((hist, i) => (
                            <Grid key={`Grid ${i}`} size={{ xs: 12, sm: 12, md: 12 }}   >
                              <Grid  >
                                <Box width="100%" display="flex" flexDirection="row" justifySelf="center" alignSelf="center">
                                  <Grid display="flex" justifyContent="start" flexDirection="column">
                                    {/* <Typography variant="body1" sx={{ paddingLeft: "10px", fontWeight: "bold" }} display="flex" alignSelf="start">
                                    {dayjs(hist.dtCriacao).format('DD/MM/YYYY HH:mm:ss')}
                                  </Typography> */}
                                    <Typography variant="body1" sx={{ paddingLeft: "10px" }} display="flex" alignSelf="center">
                                      {hist.descricao}
                                    </Typography>
                                  </Grid>
                                </Box>
                              </Grid>
                            </Grid>
                          )))}
                      </Grid>
                    </Grid>
                  </Grid>
                  {ultimosContratosRows.length > 0 && (
                    <>
                      <Grid container size={{ xs: 12, sm: 12 }} margin={1} paddingTop={3}>
                        <Grid size={{ xs: 12, sm: 12 }} >
                          <Typography variant="h6">HISTÓRICO DE CONTRATOS</Typography>
                          <hr />
                          {!removeLoading && <Loading />}
                        </Grid>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} >
                        <Box sx={{
                          height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                          '& .super-app-theme--header': {
                            backgroundColor: theme.palette.common.black,
                            color: theme.palette.common.white
                          },
                          '& .super-app.negative': {
                            color: 'red',
                            fontWeight: 'bold'
                          },
                          '& .super-app.positive': {
                            color: themeName === "light" ? "black" : "auto",
                          },
                        }}>
                          <DataGrid
                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                            autoHeight
                            getRowId={(rows) => rows.codigo_Franquia}
                            rows={ultimosContratosRows}
                            columns={columnsContratos}
                            initialState={{
                              pagination: {
                                paginationModel: {
                                  pageSize: 12,
                                },
                              },
                            }}
                            pageSizeOptions={[12]}
                            //checkboxSelection
                            disableRowSelectionOnClick
                          />
                        </Box>
                      </Grid>
                    </>)}

                  {listaMetaJogadorRows.length > 0 && (
                    <>
                      <Grid container size={{ xs: 12, sm: 12 }} margin={1} paddingTop={3}>
                        <Grid size={{ xs: 12, sm: 12 }} >
                          <Typography variant="h6">METAS DO JOGADOR</Typography>
                          <hr />
                          {!removeLoading && <Loading />}
                        </Grid>
                      </Grid>
                      <Grid container size={{ xs: 12, sm: 12 }} margin={1} paddingTop={3}>
                        <Grid size={{ xs: 12, sm: 12 }} >
                          <Typography variant="body1">{`SOMATÓRIA PONTUAÇÃO: ${listaMetaJogadorRows.map(({ pontuacao }) => pontuacao).reduce((sum, i) => sum + i, 0)}`}</Typography>
                        </Grid>
                      </Grid>

                      <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} >
                        <Box sx={{
                          height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                          '& .super-app-theme--header': {
                            backgroundColor: theme.palette.common.black,
                            color: theme.palette.common.white
                          },
                          '& .super-app.negative': {
                            color: 'red',
                            fontWeight: 'bold'
                          },
                          '& .super-app.positive': {
                           color: themeName === "light" ? "black" : "auto",
                          },
                        }}>
                          <DataGrid
                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                            autoHeight
                            getRowId={(rows) => rows.codigo}
                            rows={listaMetaJogadorRows}
                            columnVisibilityModel={{codigo: false }}
                            columns={columnsMetas}
                            initialState={{
                              pagination: {
                                paginationModel: {
                                  pageSize: 12,
                                },
                              },
                            }}
                            pageSizeOptions={[12]}
                            disableRowSelectionOnClick
                          />
                        </Box>
                      </Grid>
                    </>)}
                </Grid>
              </Grid >
            )
          }

        </Box >
      </VForm >
      {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
    </LayoutBaseDePagina >
  )
}


